<ng-container *ngIf="!loading">
	<div class="chart-wrapper">
		<div class="chart-container">
			<div class="chart-card" *ngFor="let chartOption of chartOptions; let i = index">
				<div class="chart-header">
					<div class="chart-title">{{ chartOption.title?.text }}</div>
					<div class="chart-subtitle">
						<div class="download-container" style="position: relative;">
							<button class="chart-icon" (click)="toggleDownloadMenu(i)">
								<mat-icon svgIcon="downloadIcon" class="svg-icon"></mat-icon>
							</button>

							<div class="download-popup" *ngIf="visibleDownloadMenuIndex === i">
								<button class="popup-option" (click)="downloadCSV(i)">
									<mat-icon svgIcon="csvIcon" class="svg-icon"></mat-icon>
									<span>Download CSV</span>
								</button>
								<button class="popup-option" (click)="downloadXLS(i)">
									<mat-icon svgIcon="excelIcon" class="svg-icon"></mat-icon>
									<span>Download XLS</span>
								</button>
							</div>
						</div>
						<button class="chart-icon" (click)="onTableViewClick(i)">
							<mat-icon svgIcon="tableViewIcon" class="svg-icon"></mat-icon>
						</button>
						<button class="chart-icon" (click)="onFullScreenClick(i)">
							<mat-icon svgIcon="fullScreenIcon" class="svg-icon"></mat-icon>
						</button>
					</div>
				</div>
				<p class="title-border"></p>
				<div class="chart-subtitle-wrapper">
					<div class="chart-subtitle">{{ chartOption.subtitle?.text }}</div>
				</div>
				<highcharts-chart [Highcharts]="Highcharts" [options]="chartOption"
					(chartInstance)="onChartInstance($event, i)" id="chart-container-{{ i }}"
					class="chart-list">
				</highcharts-chart>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="loading">
	<div class="loading-logo">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>
